import React from 'react';
import QuickViewIcon from '@tradera/blueprint/theme/icons2/quick-view.svg?jsx';
import { useTranslator } from 'tradera-lang';

const QuickViewButton = ({ className, iconClassName, onClick }) => {
    const { t } = useTranslator();
    return (
        <button
            aria-label={t('itemCard_quickView')}
            className={`btn btn-round btn-hover-light ${className || ''}`}
            onClick={onClick}>
            <QuickViewIcon className={`icon ${iconClassName || ''}`} />
        </button>
    );
};
export default QuickViewButton;
